var Ruler = (function () {

    var ruler = null;

    function getDistanceText(distance) {
        distance = Math.floor(distance);
        var distanceTxt;
        if (distance < 1000)
            distanceTxt = distance + '&nbsp;м';
        else
            distanceTxt = (distance / 1000) + '&nbsp;км';
        return distanceTxt.replace(".", ",");
    }

    function updateRulerPopups(ruler) {
        var points = ruler ? ruler.getLatLngs() : [];
        if (points.length) {
            var fullLength = MapHelper.getLength(points);
            $('.ruler__total-km-popup').html(getDistanceText(fullLength));

            for (var i = 0; i < points.length; i++) {
                var tooltip = points[i].__vertex.getTooltip();
                if (tooltip && i > 0) {
                    points[i].__vertex.setTooltipContent(getDistanceText(points[i].distanceTo(points[i - 1])));
                    $(tooltip._container).css('z-index', i + 10);
                } else {
                    points[i].__vertex.unbindTooltip();
                    points[i].__vertex.off('mouseover');
                    points[i].__vertex.off('mouseout');
                    if (i > 0) {
                        points[i].__vertex.bindTooltip(getDistanceText(points[i].distanceTo(points[i - 1])),
                            { permanent: true, direction: 'top', offset: L.point(0, -7), className: 'ruler__line-length' });
                        tooltip = points[i].__vertex.getTooltip();
                        $(tooltip._container).css('z-index', i + 10);

                        points[i].__vertex.on('mouseover',
                            function (e) {
                                $(this.getTooltip()._container).addClass("ruler__line-length--top");
                            }
                        );
                        points[i].__vertex.on('mouseout',
                            function (e) {
                                $(this.getTooltip()._container).removeClass("ruler__line-length--top");
                            }
                        );
                    }
                }
            }
        } else {
            for (var i = 0; i < points.length; i++) {
                points[i].__vertex.unbindTooltip();
                points[i].__vertex.off('mouseover');
                points[i].__vertex.off('mouseout');
            }
            $('.ruler__total-km-popup').html('0&nbsp;м');
        }
    }

    function init(leafletMap) {
        L.NewLineControl = L.Control.extend({

            options: {
                position: 'topleft'
            },

            onAdd: function (map) {
                var container = L.DomUtil.create('div', 'leaflet-control leaflet-bar relative leaflet-control-ruler'),
                    link = L.DomUtil.create('a', '', container);
                L.DomEvent.disableClickPropagation(container);
                link.href = '#';
                link.title = 'Линейка';
                link.innerHTML = '/\\/';
                L.DomEvent.on(link, 'click', L.DomEvent.stop)
                    .on(link, 'click', function () {

                        if (ruler) {
                            ruler.remove();
                            ruler = null;
                            $(this).removeClass('selected');
                            $('.ruler__total-km-popup').hide();
                        } else {
                            ruler = leafletMap.editTools.startPolyline();
                            $(this).addClass('selected');
                            $('.ruler__total-km-popup').show();
                        }
                        updateRulerPopups(ruler);
                    });
                var totalKmPopup = L.DomUtil.create('div', 'ruler__total-km-popup', container);
                totalKmPopup.title = 'Суммарное расстояние';
                return container;
            }
        });
        leafletMap.addControl(new L.NewLineControl());
        leafletMap.on('editable:vertex:ctrlclick editable:vertex:metakeyclick', function (e) {
            e.vertex.continue();
            updateRulerPopups(ruler);
        });
        leafletMap.on('editable:vertex:drag editable:vertex:dragend editable:vertex:new editable:vertex:deleted editable:drawing:clicked editable:drawing:end editable:dragend', function () {
            updateRulerPopups(ruler);
        });
    }

    function isActive() {
        return ruler !== null;
    }

    return {
        init: init,
        isActive: isActive
    }
}());